import { forwardRef } from "react";
import { Link as RouterLink, type LinkProps, type To } from "react-router-dom";
import { useTranslation } from "@/i18n/useTranslation";
import { localizePath } from "@/i18n/localePath";

const localizeTo = (to: To, locale: "en" | "fr"): To => {
  if (typeof to === "string") return localizePath(to, locale);
  return {
    ...to,
    pathname: to.pathname ? localizePath(to.pathname, locale) : to.pathname,
  };
};

const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...props }, ref) => {
  const { locale } = useTranslation();
  return <RouterLink ref={ref} to={localizeTo(to, locale)} {...props} />;
});

LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
